export default __webpack_public_path__ + "static/media/bg-footer-blue.6b7e6e07.png";